export class PlatformsBrowserSessionError extends Error {
  constructor(
    message: string,
    readonly status: number,
  ) {
    super(message);
    this.name = "PlatformsBrowserSessionError";
  }
}

let bootstrapPromise: Promise<void> | null = null;
let isBootstrapped = false;

export async function ensurePlatformsSession() {
  if (isBootstrapped) return;
  if (bootstrapPromise) return bootstrapPromise;

  bootstrapPromise = fetch("/api/auth-central/platforms-session", {
    cache: "no-store",
    method: "POST",
  })
    .then(async (response) => {
      if (!response.ok) {
        const payload = await response.json().catch(() => ({}));
        throw new PlatformsBrowserSessionError(
          payload.message ?? "Platforms authentication failed",
          response.status,
        );
      }
      isBootstrapped = true;
    })
    .finally(() => {
      bootstrapPromise = null;
    });

  return bootstrapPromise;
}

export function resetPlatformsSessionState() {
  isBootstrapped = false;
  bootstrapPromise = null;
}
